import React, { useState, useEffect } from "react";
import MiniDrawer from "../../components/MiniDrawer/MiniDrawer";
import Wrapper from "../../components/UI/Wrapper";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import axios from "axios";
import "../SubCostCenterMaster/SubCostCenterMaster.css"; // Assuming you have a CSS file for styles

const CostCenterMaster = () => {
  const [costCenters, setCostCenters] = useState([]);
  const baseAPI = process.env.REACT_APP_API_URL;

  const [costCenterData, setCostCenterData] = useState({
    cost_center_name: "",
  });

  // Fetch cost centers from API
  const fetchCostCenters = async () => {
    try {
      const storedToken = JSON.parse(localStorage.getItem("token"));

      const response = await axios.get(
        `${baseAPI}adminget/GetCostCenter?cost_center_id=0`,
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      );

      const allCenters = response.data?.data;

      if (Array.isArray(allCenters)) {
        const activeCenters = allCenters.filter(
          (item) => item.is_active === true
        );
        setCostCenters(activeCenters);
      } else {
        console.error("Invalid data format:", response.data);
        alert("Unexpected data format received.");
      }
    } catch (error) {
      console.error("Fetch error:", error.response || error);
      alert("Failed to fetch cost centers.");
    }
  };

  useEffect(() => {
    fetchCostCenters();
  }, []);

  // Add new cost center
  const handleAddCostCenter = async () => {
    if (!costCenterData.cost_center_name.trim()) {
      alert("Please enter a cost center name.");
      return;
    }

    console.log("Sending cost center:", costCenterData);

    try {
      const storedToken = JSON.parse(localStorage.getItem("token"));
      const response = await axios.post(
        `${baseAPI}adminPost/AddConstCenter`,
        costCenterData,
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200 || response.status === 201) {
        console.log("data sent", costCenterData);
        alert("Cost center added successfully!");
        setCostCenterData({ name: "" });
        fetchCostCenters();
      } else {
        alert("Failed to add cost center.");
      }
    } catch (error) {
      console.error("Add error:", error.response || error);
      alert("An error occurred while adding cost center.");
    }
  };

  // Delete cost center (soft delete)
 const handleDelete = async (id) => {
  if (!window.confirm("Are you sure you want to delete this cost center?")) return;

  try {
    const storedToken = JSON.parse(localStorage.getItem("token"));
    const response = await axios.post(
      `${baseAPI}adminPost/DeleteConstCenter`,
      { cost_center_id: id.toString() }, // <- sending correct body
      {
        headers: {
          Authorization: `Bearer ${storedToken}`,
          "Content-Type": "application/json",
        },
      }
    );

    if (response.status === 200 || response.status === 204) {
      alert("Cost center deleted successfully.");
      fetchCostCenters();
    } else {
      alert("Failed to delete cost center.");
    }
  } catch (error) {
    console.error("Delete error:", error.response || error);
    alert("An error occurred while deleting the cost center.");
  }
};



  const handleChange = (e) => {
    const { name, value } = e.target;
    setCostCenterData((prevItem) => ({
      ...prevItem,
      [name]: value,
    }));
  };

  return (
    <div className="d-flex flex-row app">
      <MiniDrawer />
      <div
        className="container-fluid"
        style={{ padding: "4rem 1rem 1rem 1rem", backgroundColor: "#F4F4F4" }}
      >
        <div className="d-flex flex-column w-100">
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <h1 style={{ fontSize: "24px", marginBottom: "2rem" }}>
              Cost Center | <HomeOutlinedIcon />{" "}
              <span style={{ fontSize: "20px" }}>&gt; Master</span>
            </h1>
            <div style={{ width: "8rem" }}>
              <select className="form-control" name="country">
                <option value="0">INDIA</option>
                <option value="1">DUBAI</option>
              </select>
            </div>
          </div>

          <Wrapper className="ViewLeadDetails mb-2">

            <div className="row">
              <div className="col-6">
                {/* Input form */}
            <div className="form-group mb-3">
              <label htmlFor="costCenterInput">Enter Cost Center</label>
              <input
                type="text"
                className="form-control"
                name="cost_center_name"
                value={costCenterData.cost_center_name}
                onChange={handleChange}
                placeholder="Enter name"
              />
            </div>
              </div>
              <div className="col-6">
                 <div className="form-group mb-3 text-end">
                   <button
              className="btn btn-primary mb-4"
              onClick={handleAddCostCenter}
            >
              Add Cost Center
            </button>
                 </div>
               
              </div>
            </div>
            
            </Wrapper>
 <Wrapper className="ViewLeadDetails">
            {/* List Table */}
            <h5>Cost Center List</h5>
            <table className="table table-bordered">
              <thead className='SubCostCenterMaster-thead'>
                <tr>
                  <th>S.No</th>
                  <th>Cost Center Name</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody className='SubCostCenterMaster-tbody'>
                {Array.isArray(costCenters) && costCenters.length > 0 ? (
                  costCenters.map((center, index) => (
                    <tr key={center.cost_center_id || index}>
                      <td>{index + 1}</td>
                      <td>{center.cost_center_name}</td>
                      <td className='SubCostCenterMaster-td4'>
                        <button
                          className="btn btn-link text-danger p-0"
                          onClick={() => handleDelete(center.cost_center_id)}
                        >
                          <i className="fas fa-times"></i>
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="3" className="text-center">
                      No data found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </Wrapper>
        </div>
      </div>
    </div>
  );
};

export default CostCenterMaster;
